var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topback',{attrs:{"title":"TT Notice","path":"back"}}),_vm._v(" "),_c('md-field',{staticClass:"mt-6"},_vm._l((_vm.news_list),function(item){return _c('newitem',{key:item.id,attrs:{"name":item.name,"ctime":item.ctime,"id":item.id}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-419f0c21","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/news.vue
// module id = null
// module chunks = 